module.exports = __webpack_public_path__ + "static/media/terms_and_conditions.7f35a740.svg";